// src/API/utils/adaptarEventos.js

// Mapeia os tipos do backend para algo que sua UI entenda como "Tipo"
const mapTipoUI = (rawType) => {
  // A/B/C/D/I são eventos de dispositivos/monitoramento no seu exemplo
  // Ajuste se quiser classificar diferente (ex.: "Alarmes", etc.)
  return "Dispositivos";
};

// Descrição amigável para a tabela
const montarDescricao = (e) => {
  const { type, previous_state, new_state, error_message, device_name } = e || {};
  switch (type) {
    case "A":
      return `${device_name || "Dispositivo"} ficou OFFLINE`;
    case "B":
      return `${device_name || "Dispositivo"} ficou ONLINE`;
    case "C":
      return `Servidor de Monitoramento OFFLINE${error_message ? `: ${error_message}` : ""}`;
    case "D":
      return `Servidor de Monitoramento ONLINE${error_message ? `: ${error_message}` : ""}`;
    case "I":
      return `Instabilidade detectada${error_message ? `: ${error_message}` : ` (${previous_state} → ${new_state})`}`;
    default:
      return error_message || `${previous_state || "-"} → ${new_state || "-"}`;
  }
};

// Converte timestamp ISO (UTC) para data/hora em pt-BR (São Paulo)
const toBRDateTime = (iso) => {
  if (!iso) return { data: "-", hora: "-" };
  const d = new Date(iso);
  const data = d.toLocaleDateString("pt-BR", { timeZone: "America/Sao_Paulo" }); // dd/mm/aaaa
  const hora = d.toLocaleTimeString("pt-BR", { timeZone: "America/Sao_Paulo", hour12: false }); // HH:MM:SS
  return { data, hora };
};

// Se você tiver a lista de "chamados", dá pra achar o status por id
const acharStatusChamado = (chamado_id, chamados) => {
  if (!chamado_id || !Array.isArray(chamados)) return null;
  const ch = chamados.find(c => c?.id === chamado_id);
  return ch?.status ?? null; // ajuste conforme o shape do seu "chamado"
};

/**
 * Adapta o array "data" do backend para o que o componente Eventos espera.
 */
export default function adaptarEventosParaUI(data = [], chamados = []) {
  if (!Array.isArray(data)) return [];

  // ordena DESC por timestamp
  const ordenados = [...data].sort((a, b) => {
    const ta = Date.parse(a?.timestamp || 0);
    const tb = Date.parse(b?.timestamp || 0);
    return tb - ta;
  });

  return ordenados.map((e) => {
    const { data, hora } = toBRDateTime(e?.timestamp);

    return {
      // Campos que seu componente usa:
      nome: e?.device_name || "-",          // seu <td>{evento.nome}</td>
      tipo: mapTipoUI(e?.type),             // seu filtro "Tipo"
      descricao: montarDescricao(e),        // seu <td>{evento.descricao}</td>
      ip: e?.device_ip || "-",              // seu <td>{evento.ip}</td>
      data,                                 // seu <td>{evento.data}</td>
      hora,                                 // seu <td>{evento.hora}</td>
      chamado_status: acharStatusChamado(e?.chamado_id, chamados) || "Nenhum chamado associado",

      // Extras úteis se precisar abrir detalhes:
      _id: e?.id,
      _raw_type: e?.type,
      _timestamp: e?.timestamp,
      _previous_state: e?.previous_state,
      _new_state: e?.new_state,
      _chamado_id: e?.chamado_id,
      _error_message: e?.error_message
    };
  });
}
